import MainNavbar from "../../examples/Navbars/MainNavbar";
import React, { useState } from "react";
import MainLayout from "../../examples/LayoutContainers/MainLayout";
import {
  useDeleteBrandLogo,
  useGetMerchantById,
  useUploadBrandLogo,
  useUpdateCashierTheme,
} from "./hooks";
import SettingsColorPresets from "./components/SettingsColorPresets";
import { useForm } from "react-hook-form";
import FormProvider from "../../components/FormProviders";
import { getToken } from "../../utils/cache";
import { useMerchantStore } from "../../stores/merchant";

const SettingsPage = () => {
  const [cashierTheme, setCashierTheme] = useState(null);

  const { selectedPreviewBrand } = useMerchantStore();
  useGetMerchantById();

  // hooks
  const { mutateAsync: uploadBrandLogo, isLoading: isUploadingBrandLogo } = useUploadBrandLogo();
  const { mutateAsync: deleteBrandLogo, isLoading: isDeletingBrandLogo } = useDeleteBrandLogo();
  const { mutateAsync: updateCashierTheme, isLoading: isLoadingUpdateCashierTheme } =
    useUpdateCashierTheme();

  const methods = useForm({
    defaultValues: {
      logo: null,
      removeLogo: false,
    },
  });
  const { handleSubmit } = methods;

  const handleSubmitForm = async (values) => {
    if (!selectedPreviewBrand) {
      return;
    }

    const updates = [];
    if (values.removeLogo === true) {
      updates.push(deleteBrandLogo({ brandId: selectedPreviewBrand }));
    }

    if (values.logo) {
      const formData = new FormData();
      formData.append("logo", values.logo);
      updates.push(uploadBrandLogo({ brandId: selectedPreviewBrand, formData }));
    }
    if (cashierTheme) {
      updates.push(
        updateCashierTheme({
          brandId: selectedPreviewBrand,
          cashierTheme: cashierTheme,
          v3CashierTheme: cashierTheme,
        })
      );
    }

    if (updates.length > 0) {
      try {
        await Promise.all(updates);
      } catch {
        // Error toasts are handled in request interceptors.
      }
    }
  };

  return getToken() ? (
    <MainLayout>
      <MainNavbar />

      <FormProvider methods={methods} onSubmit={handleSubmit(handleSubmitForm)}>
        <SettingsColorPresets
          loading={isUploadingBrandLogo || isDeletingBrandLogo || isLoadingUpdateCashierTheme}
          setCashierTheme={setCashierTheme}
        />
      </FormProvider>
    </MainLayout>
  ) : (
    (window.location.href = "/sign-in")
  );
};

export default SettingsPage;
